import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "input-item" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["input-item__label", `${_ctx.fileNameValue ? 'selected' : ''}`]),
      style: _normalizeStyle(_ctx.labelStyle)
    }, [
      (_ctx.fileNameValue)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.fileNameValue), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1)),
      _createElementVNode("input", {
        type: "file",
        value: _ctx.inputValue,
        onChange: _cache[0] || (_cache[0] = (e) => _ctx.importFile(e))
      }, null, 40, _hoisted_4)
    ], 6)
  ])), [
    [
      _directive_tooltip,
      _ctx.fileNameValue,
      void 0,
      { bottom: true }
    ]
  ])
}